export default __webpack_public_path__ + "media/metronic/_theme/media/error/bg1-bfaf6e25705b69cba285341194b3944a.jpg";